import { useState } from 'react';
import classnames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'app/lib/hooks';
import {
    doSetUserSessionWarehouse,
    selectUserSessionWarehousesItemInProgress
} from 'app/store/snowflake';
import { selectWarehouseStatuses } from 'app/store/healthcheck';
import { Button, ButtonEdge, ButtonSize, ButtonVariant } from 'app/components/core/Button';
import { WarehouseCard, CardList } from 'app/components/composite/WarehouseCard';
import { Header } from './Header.jsx';
import * as styles from './WarehouseLoadDialog.css';

const cx = classnames.bind(styles);

export function WarehouseSelector({ current, options, log, onCancel }) {
    const { t } = useTranslation('components', { keyPrefix: 'WarehouseLoadDialog.warehouses' });
    const dispatch = useDispatch();
    const statusByName = useSelector(selectWarehouseStatuses);
    const isChangingWarehouse = useSelector(selectUserSessionWarehousesItemInProgress);
    const [selectedWarehouse, setSelectedWarehouse] = useState(current);

    function handleClick(warehouse, isSelected) {
        if (!isSelected) {
            setSelectedWarehouse(warehouse);
            dispatch(doSetUserSessionWarehouse({ warehouse }));
            log(`Changed warehouse from "${current}" to "${warehouse}".`);
        }
    }

    return (
        <section className={cx('content-pane')}>
            <Header icon="warehouse" title={t('header')}>
                <Button
                    variant={ButtonVariant.SECONDARY_BLUE}
                    size={ButtonSize.SMALL}
                    edge={ButtonEdge.FLAT}
                    onClick={onCancel}>
                    {t('back')}
                </Button>
            </Header>
            <CardList>
                {options.map((wh) => {
                    const { name, isSelected } = wh;
                    const status = statusByName[name];

                    return (
                        <WarehouseCard
                            key={name}
                            name={name}
                            state={status?.state}
                            running={status?.running}
                            queued={status?.queued}
                            size={status?.size}
                            disabled={status?.state === 'OVERLOADED'}
                            isSelected={isSelected}
                            isProcessing={name === selectedWarehouse && isChangingWarehouse}
                            onClick={() => handleClick(name, isSelected)}
                        />
                    );
                })}
            </CardList>
        </section>
    );
}
